import React from 'react';

const FourHorizontalLines = ({ color = '#424242', width = 20, height = 21, ...rest }, ref) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      ref={ref}>
      <path d="M4 5.5H20V7.5H4V5.5ZM4 9.5H20V11.5H4V9.5ZM4 13.5H20V15.5H4V13.5ZM4 17.5H14V19.5H4V17.5Z" fill={color} />
    </svg>
  );
};

export default React.forwardRef(FourHorizontalLines);
